<script>
    import ImgRoundBox from "@songfinch/shared/components/ImgRoundBox.vue";

    export default {
        name: "Error",
        components: {ImgRoundBox},
        computed: {
            data() {
                return this.$store.state.cms.pageData;
            }
        }
    };
</script>

<template>
    <div class="page errorPage @pt-0 tablet-lg:@pt-8">
        <template v-if="data">
            <div class="@container @pb-26 @max-w-[1075px]">
                <div class="@grid @grid-cols-12 tablet:@gap-x-10 @items-center">
                    <div class="@col-span-12 tablet:@col-span-6">
                        <div class="@my-3">
                            <ImgRoundBox :image="data.image" alt="error"/>
                        </div>
                    </div>
                    <div class="@col-span-12 tablet:@col-span-6 @text-center tablet:@text-left">
                        <div class="headerLineAfter l2" v-html="data.page_title"/>
                        <h1 v-if="data.title" class="@mb-4" v-html="data.title"/>
                        <div v-if="data.subtitle " class="p1 @text-sfc-dark-grey" v-html="data.subtitle"/>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style>
    .headerLineAfter {
        text-transform: uppercase;
        color: var(--cherry);
        position: relative;
        padding-bottom: 10px;
        margin-bottom: 30px;

        &:after {
            content: "";
            position: absolute;
            height: 1px;
            width: 30px;
            bottom: 0;
            left: 0;
            background-color: var(--cherry);
        }

        @screen mobile {
            text-align: center;
            &:after {
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
</style>
